import { render } from "./CxList.vue?vue&type=template&id=0b54b90a&scoped=true&ts=true"
import script from "./cxListHelper.ts?vue&type=script&lang=ts"
export * from "./cxListHelper.ts?vue&type=script&lang=ts"

import "./CxList.vue?vue&type=style&index=0&id=0b54b90a&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b54b90a"]])

export default __exports__